<template>
    <div class="badge-list">
        <h1>{{ title }}</h1>
        <div v-if="badges.length"
            class="badge-list__container"
        >
            <div v-for="(badge, index) in badges"
                :key="index"
                class="badge-list__item"
            >
                <single-badge :badgeData="badge" />
            </div>
        </div>
        <div v-else
            class="badge-list__container badge-list__container--no-badges"
            @click="noBadgesOnTap"
        >
            <p>
                {{ noBadgesText || $t('rewards.badges.noBadges') }}
            </p>
        </div>
    </div>
</template>

<script>
// Components
import singleBadge from '@webapp/modules/rewards/components/badges/single-badge.vue';

export default {
    name: 'badge-list',
    components: {
        singleBadge,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        badges: {
            type: Array,
            default: () => ([]),
            required: true,
        },
        noBadgesText: {
            type: String,
            default: '',
        },
        noBadgesOnTap: {
            type: Function,
            default: () => ({}),
        },
    },
};
</script>

<style lang="scss" scoped>
.badge-list {
    margin: 1rem;

    @include min-width(md) {
        margin: 3rem;
    }

    @include min-width(lg) {
        margin: 6rem;
    }

    h1 {
        color: $daintree-color;
        font-size: 2.5rem;
    }

    &__container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 0 0;

        @include min-width(md) {
            grid-template-columns: 1fr 1fr 1fr;
        }

        @include min-width(lg) {
            grid-template-columns: 1fr 1fr 1fr 1fr;
            padding: 4rem;
        }

        background-color: $white-color;
        border-radius: 1rem;
        padding: 1.5rem;
        color: $daintree-color;

        &--no-badges {
            font-size: 1.5rem;
            cursor: pointer;
            display: block;
        }
    }

    &__item {
        display: flex;
    }
}
</style>